//api 请求的前缀

export const OPERATION_CENTER_PREFIX = '/operation-center-service'
export const USER_AUTH_LIST_KEY = `user_auth_list`
export const TOKEN_KEY = `token`
export const SYSTEM_KEY = `system_info`
